import { render, staticRenderFns } from "./BillingCurrentPlan.vue?vue&type=template&id=dc5464b0&scoped=true&"
import script from "./BillingCurrentPlan.vue?vue&type=script&lang=js&"
export * from "./BillingCurrentPlan.vue?vue&type=script&lang=js&"
import style0 from "./BillingCurrentPlan.vue?vue&type=style&index=0&id=dc5464b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5464b0",
  null
  
)

export default component.exports